
import { Component, Input, OnInit, SimpleChanges, OnChanges, ViewChild} from '@angular/core';
import { Carousel } from 'primeng/carousel';
import { ButtonTypesEnum } from '../../../Common/Forms/enums/button-types.enum';
import { messageSeverityEnum } from '../../../Common/Misc/enums/message-severity.enum';
import { RecentActivities } from 'app/LandingPage/models/recent-activities.model';

enum ToggleViewEnum {
    account = 'account',
    user = 'user'
}
@Component({
    selector: 'agpr-recent-activities',
    templateUrl: './recent-activities.html',
    styleUrls: ['./recent-activities.scss'],
    standalone: false
})

export class RecentActivitiesComponent implements OnInit, OnChanges {
    @Input() recentActivities: RecentActivities[] = [];
    @Input() userRecentActivities: RecentActivities[] = [];
    @Input() loading: boolean = true;
    @Input() id: string;
    @Input() isReseller: boolean;

    responsiveOptions: any[];
    messageSeverityEnum: messageSeverityEnum = messageSeverityEnum.noContent;

    selectedViewMode: ToggleViewEnum = ToggleViewEnum.account;
    carouselValue: RecentActivities[] = [];
    toggleTitle: string;
    defaultNumVisible: number;
    hasContent: boolean = false;
    showToggleButton: boolean;

    readonly buttonTypes = ButtonTypesEnum;
    @ViewChild(Carousel) carousel: Carousel;

    constructor() {
        this.defaultNumVisible = this.isReseller ? 5 : 4;
        this.responsiveOptions = this.getResponsiveOptions();
    }

    ngOnInit(): void {
        this.updateDisplayedActivities();
        this.toggleLabel();
    }

    toggleView(): void {
        if (this.carousel) {
            this.carousel.page = 0;
        }
        if (this.selectedViewMode === ToggleViewEnum.account) {
            this.selectedViewMode = ToggleViewEnum.user;
            this.carouselValue = this.userRecentActivities;
        } else {
            this.selectedViewMode = ToggleViewEnum.account;
            this.carouselValue = this.recentActivities;
        }
        this.toggleLabel();
        this.updateDisplayedActivities();
    }

    toggleLabel(): void {
        if (this.selectedViewMode === ToggleViewEnum.account) {
            this.toggleTitle = 'LandingPage.main.recentActivities.toggle.userLabel';
        } else {
            this.toggleTitle = 'LandingPage.main.recentActivities.toggle.accountLabel';
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['recentActivities'] && this.selectedViewMode === ToggleViewEnum.account) {
            this.carouselValue = this.recentActivities || [];
            this.showToggleButton = this.recentActivities?.length > 0;
        }

        if (changes['userRecentActivities'] && this.selectedViewMode === ToggleViewEnum.user) {
            this.carouselValue = this.userRecentActivities || [];
        }

        if (changes['userRecentActivities'] || changes['recentActivities']) {
            this.updateDisplayedActivities();
        }

        if (changes['isReseller']) {
            this.defaultNumVisible = this.isReseller ? 5 : 4;
            this.responsiveOptions = this.getResponsiveOptions();
        }
    }

    updateDisplayedActivities(): void {
        this.carouselValue = this.selectedViewMode === ToggleViewEnum.user
            ? this.userRecentActivities || [] : this.recentActivities || [];

        this.hasContent = this.carouselValue.length > 0;
    }

    getResponsiveOptions() {
        if (this.isReseller) {
            return [
                { breakpoint: '1480px', numVisible: 5, numScroll: 5 },
                { breakpoint: '1479px', numVisible: 4, numScroll: 4 }
            ];
        } else {
            return [
                { breakpoint: '1480px', numVisible: 4, numScroll: 4 },
                { breakpoint: '1479px', numVisible: 3, numScroll: 3 }
            ];
        }
    }
}
